import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../utils/axios.ts';

export function useSubgroupMembers(memberId: number | undefined) {
  return useQuery({
    queryKey: ['subgroup-members', memberId],
    queryFn: async () => {
      const res = await api.get(`/members/${memberId}/subgroup-members`);
      return res.data;
    },
    enabled: !!memberId,
  });
}

export function useSubgroupMemberPayments(memberId: number, subgroupMemberId: number) {
  return useQuery({
    queryKey: ['subgroup-member-payments', memberId, subgroupMemberId],
    queryFn: async () => {
      const res = await api.get(`/members/${memberId}/subgroup-members/${subgroupMemberId}/payments`);
      return res.data;
    },
    enabled: !!memberId && !!subgroupMemberId,
  });
}

export function useAddSubgroupMember(memberId: number) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: { name: string; phone_number: string; email?: string }) => {
      const res = await api.post(`/members/${memberId}/subgroup-members`, data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['subgroup-members', memberId] });
    },
  });
}

export function useUpdateSubgroupMember(memberId: number) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, ...data }: { id: number; name?: string; phone_number?: string; email?: string; status?: string }) => {
      const res = await api.put(`/members/${memberId}/subgroup-members/${id}`, data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['subgroup-members', memberId] });
    },
  });
}
